function WhoWeAreScreen() {
  return (
    <section className="mx-auto w-full max-w-4xl">
      <article className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
        <h2 className="mb-4 text-3xl font-semibold text-slate-900">Who We Are</h2>
        <p className="mb-3 text-sm leading-6 text-slate-700">
          ProShare is a resource marketplace built to connect professionals with
          practical, high-quality materials they can use in real sessions.
        </p>
        <p className="mb-3 text-sm leading-6 text-slate-700">
          The platform focuses on clear discovery, trusted creators, and reusable
          digital resources designed for daily practice.
        </p>
        <p className="text-sm leading-6 text-slate-700">
          Our goal is to keep improving quality, discoverability, and creator
          support while maintaining a secure and transparent experience.
        </p>
      </article>
    </section>
  );
}

export default WhoWeAreScreen;
